let data = [
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: true
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: false
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: true
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: false
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: true
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: false
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: true
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: true
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: false
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: false
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: true
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: false
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: true
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: true
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: false
},
{
    img: require('../assets/image/img/首页/list_img.png'),
    name: '南瓜',
    discountPrice: 6.5,
    price: 7,
    flag: true
}, ]
export default
{
    data
}